import React from 'react';


export default class ThankYou extends React.Component {
  constructor(props) {
    super();
    this.props = props;
    this.state = {

    };
  }

  componentWillMount() {

  }


  render() {
    return (
      <div className="thankyou container">
        <section className="row row--push-btm-s">
          <div className="col-12" style={{textAlign: 'center'}}>
            <i className="ion ion-checkmark-circled" style={{fontSize: '8em', color:'grey', display:'inline-block', padding:'20px 0'}}></i>
          </div>
        </section>
        <section className="row">
          <div className="col-12 text-center">
            <div className="card">
              <h2 className="h--no-spacing">Thank you</h2>
              <h5 className="h--normalize-weight h--lower h--spacing-sm">Your payment was received</h5>
              <span>
                Welcome to the world of video art.
              </span>
            </div>
          </div>
        </section>
        <section className="row">
          <div className="col-12">
            <section className="row">
              <div className="col-12 text-center">
                <h4>Get started:</h4>
              </div>
            </section>
            <section className="row">
              <div className="col-4 resource">
                <div className="card">
                  <img src="https://blackdove.com/images/resources-icons/ios-journal.svg" alt="ios" />
                  <span>Quick Start Guide</span>
                  <a rel="noopener noreferrer" href="https://drive.google.com/open?id=1mT9VDdGaqr9xFzRvHl8aNldVLodNjmHA#" target="_blank" className="btn btn--outlined">Download</a>
                </div>
              </div>
              <div className="col-4 resource">
                <div className="card">
                  <img src="https://blackdove.com/images/resources-icons/ios-appstore.svg" alt="ios" />
                  <span>iPhone (iOS) App</span>
                  <a rel="noopener noreferrer" href="https://itunes.apple.com/us/app/blackdove-video-art/id943637063?mt=8" target="_blank" className="btn btn--outlined">Download</a>
                </div>
              </div>
              <div className="col-4 resource">
                <div className="card">
                  <img src="https://blackdove.com/images/resources-icons/md-appstore.svg" alt="ios" />
                  <span>Android App</span>
                  <a rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.blackdove.blackdove&hl=en" target="_blank" className="btn btn--outlined">Download</a>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>
    );
  }
}
